module.exports = __webpack_public_path__ + "media/golfhub/event_dashboard_logo-f790afe9.svg";